import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon.js';

interface SafeLinkProps {
  href?: string | undefined;
  children?: React.ReactNode;
  isBlocked: boolean;
}

export function SafeLink({ href, children, isBlocked }: SafeLinkProps) {
  const { t } = useTranslation();

  if (!href) return <span>{children}</span>;

  let domain = '';
  try {
    domain = new URL(href).hostname;
  } catch {
    domain = href;
  }

  if (isBlocked) {
    return (
      <span
        title={t('safelink.blocked_title')}
        style={{ display: 'inline-flex', alignItems: 'center', gap: '3px', color: '#f59e0b', cursor: 'not-allowed' }}
      >
        <Icon name="alert" size={12} strokeWidth={2} />
        <span style={{ textDecoration: 'line-through', opacity: 0.6 }}>{children}</span>
        <span style={{ fontSize: '10px', opacity: 0.6 }}>[{domain}]</span>
      </span>
    );
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'underline' }}
      >
        {children}
      </a>
      <span style={{ fontSize: '10px', opacity: 0.5 }}>[{domain}]</span>
    </span>
  );
}
